import script from "./FileAttachment.vue?vue&type=script&setup=true&lang=js"
export * from "./FileAttachment.vue?vue&type=script&setup=true&lang=js"

import "./FileAttachment.vue?vue&type=style&index=0&id=53df976f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53df976f"]])

export default __exports__